/**
 * Staggered fade-in when containers scroll into view (class .is-in-view).
 *
 * @author jjarolim
 */

import { init as initInViewObserver } from './in-view-observer.js';

const STAGGER_MS = 250;

const FADE_IN_TARGETS = [
    {
        selector: '.wp-block-gallery.css-fade-in',
        children: ':scope > figure.wp-block-image',
    },
    {
        selector: '.wp-block-bmw-teaser',
        children: '.bmw-teaser-content > *',
    },
];

const init = () => {
    FADE_IN_TARGETS.forEach( ( { selector, children } ) => {
        initInViewObserver( selector, {
            once: true,
            onIntersect: container => {
                container.querySelectorAll( children ).forEach( ( element, index ) => {
                    element.style.setProperty( '--fade-in-delay', `${ index * STAGGER_MS }ms` );
                } );
            },
        } );
    } );
};

export { init };
